module.exports = __webpack_public_path__ + "static/media/armor.99a0b827.svg";